import { useQueries } from '@tanstack/react-query'

import type { PlantAssessment } from '@/features/assessments/api/assessment-list'
import { installationPhaseListOptions } from '@/features/plant-assessment/api/installation-phase-list'

type UseSyncedAssessmentIdsParams = {
  assessments: PlantAssessment[]
  enabled: boolean
}

// Ids of the assessments with at least one phase already sent to the Platform.
// The list response carries no phases, so they are fetched per row — only for
// rows with a company, the only ones that can be opened on the Platform.
export function useSyncedAssessmentIds({ assessments, enabled }: UseSyncedAssessmentIdsParams) {
  const candidates = enabled ? assessments.filter(a => Boolean(a.companyID)) : []

  return useQueries({
    queries: candidates.map(a => installationPhaseListOptions(a.id)),
    combine: results =>
      new Set(
        candidates
          .filter((_, i) => results[i]?.data?.some(phase => Boolean(phase.lastSyncedAt)))
          .map(a => a.id)
      )
  })
}
